import { Loader } from "@storybook"; // Importing the Loader component for loading states
import { useInstance } from "hooks"; // Importing custom hook to get instance data
import { FC, useEffect, useState } from "react"; // Importing necessary hooks and types from React
import { InjectScript, SITE_META } from "utils"; // Importing utilities for script injection and site metadata

import "./onboarding-flow.scss"; // Importing the SCSS file for styling

let isLoaded = false; // Flag to track if scripts have been loaded

interface IOnboardingFlow {
  onStepChange: (event: any) => void; // Function to handle step change
  id: string; // ID for the onboarding flow
  onComplete: (e: string) => void; // Function to handle completion of the onboarding flow
}

// Main OnboardingFlow component
export const OnboardingFlow: FC<IOnboardingFlow> = ({
  onStepChange,
  onComplete,
  id,
}) => {
  const [loading, setLoading] = useState(true); // State to track loading status
  const { env } = useInstance(); // Get environment data using custom hook

  const appendScripts = async () => {
    const url = SITE_META[(env as "prod") ?? "prod"].onboardingUrl; // Get the onboarding URL from site metadata
    await InjectScript([
      {
        type: "script",
        link: url, // Link to the onboarding script
      },
    ]);
    setLoading(false); // Set loading to false after scripts are loaded
  };

  useEffect(() => {
    if (!isLoaded) {
      isLoaded = true; // Mark scripts as loaded
      appendScripts(); // Load the scripts
    } else {
      setLoading(false); // If scripts are already loaded, set loading to false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <Loader />; // Show loader while scripts are loading
  }

  (window as any).onStepChange = function (item: any) {
    onStepChange(item); // Assign onStepChange handler to window object
  };

  (window as any).onSessionComplete = function (sessionId: string) {
    onComplete(sessionId); // Assign onComplete handler to window object
  };

  return (
    // Render the custom element with the given ID and handlers
    <div
      dangerouslySetInnerHTML={{
        __html: `
        <simplici-onboarding
           code=${id}
           handleChange="onStepChange"
           onComplete="onSessionComplete"
           env=${env}
        />`,
      }}
    />
  );
};
